"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconHandHoldingHeart = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconHandHoldingHeart = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsxs)("svg", _objectSpread(_objectSpread({
    width: "50",
    height: "40",
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M48.6809 23.948C47.5559 22.6353 45.2615 21.3922 42.2062 21.8685L31.541 23.5085C30.2341 22.2732 28.4178 21.7271 26.6461 22.0369L19.5519 23.1406C18.6108 22.0873 15.5709 19.0977 11.8861 19.665L8.78995 20.1394L8.65248 19.2352V19.2371C8.45691 17.9844 7.28547 17.1246 6.03074 17.3144L1.94325 17.9475V17.9495C0.692438 18.147 -0.163415 19.3184 0.0263337 20.5712L2.48925 36.5244C2.68288 37.7791 3.85626 38.6388 5.11099 38.4452L9.20041 37.8178C9.80257 37.7249 10.3428 37.3957 10.701 36.902C10.701 36.902 10.732 36.8516 10.7475 36.8245C13.0768 37.5255 21.4781 39.9922 23.8346 39.9922V39.9942C23.9392 40.0019 24.0437 40.0019 24.1463 39.9942C25.281 39.8199 31.3011 36.5863 40.2948 31.68C44.3823 29.4669 48.2005 27.3776 49.0546 27.0194L49.3818 26.8819L49.4883 26.545C49.7284 25.7841 49.4264 24.8217 48.6809 23.9485L48.6809 23.948ZM9.46959 35.9937C9.34954 36.1603 9.16365 36.2706 8.95844 36.2997L4.87095 36.9328C4.45465 36.9909 4.06739 36.7005 4.00736 36.2842L1.53473 20.3349C1.47083 19.9186 1.75546 19.5275 2.17372 19.4617L6.2612 18.8285H6.37931C6.7627 18.8169 7.0938 19.0938 7.15576 19.4714L9.60901 35.4266C9.63999 35.626 9.58965 35.8293 9.4696 35.9939L9.46959 35.9937ZM39.5632 30.3146C33.729 33.4785 24.9697 38.261 23.9124 38.4608C22.8552 38.6602 15.8535 36.7588 11.1371 35.3375V35.1884L9.03621 21.6597L12.1323 21.1795C15.5963 20.6683 18.6109 24.3995 18.6422 24.4401L18.9191 24.7926L26.8753 23.5669C30.4516 23.0054 32.026 26.4229 32.5584 28.0222L17.5966 30.3264L17.8309 31.86L34.4537 29.3041L34.2853 28.5063C33.9948 27.2265 33.4662 26.0144 32.7266 24.9301L42.4351 23.4275C44.8787 23.05 46.6562 23.9852 47.5099 24.9862C47.7404 25.2302 47.9146 25.5206 48.0211 25.8401C46.658 26.452 43.4728 28.185 39.5637 30.3148L39.5632 30.3146Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M25.0411 18.8633L25.4032 19.0569L25.7653 18.8633C26.199 18.6329 36.4205 13.099 36.4205 5.8882C36.4573 4.314 35.8455 2.79402 34.7302 1.68066C33.6149 0.569233 32.093 -0.0387766 30.5187 0.00191927C28.4043 0.00772823 26.4545 1.14626 25.4087 2.98571C24.3592 1.13848 22.3978 -0.00194709 20.2739 0.00191927C18.6997 -0.0348696 17.1797 0.573099 16.0663 1.68646C14.953 2.79982 14.345 4.3198 14.3818 5.894C14.3818 13.0988 24.5954 18.6327 25.0411 18.8632L25.0411 18.8633ZM20.274 1.53557C22.6788 1.53751 24.6287 3.48734 24.6325 5.89415H26.1661C26.168 3.48928 28.114 1.54142 30.5188 1.53557C31.6864 1.49491 32.8191 1.94026 33.6459 2.76706C34.4727 3.59386 34.9181 4.72656 34.8774 5.89415C34.8774 11.484 27.171 16.2823 25.3974 17.3103C23.6238 16.288 15.9174 11.4959 15.9174 5.89415H15.9193C15.8786 4.72656 16.324 3.5958 17.1508 2.76899C17.9757 1.94219 19.1064 1.49686 20.274 1.53557H20.274Z",
      fill: color
    }, void 0)]
  }), void 0);
});